import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { loginRequest } from '../model/common/common.model';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClientService: HttpClientService) { }

  public login(data: loginRequest) {
    return this.httpClientService.post(CONFIG.AUTH.LOGIN, data);
  }
  public createuser(data: any) {
    return this.httpClientService.post(CONFIG.AUTH.CREATEUSER, data);
  }
  public createuserRole(Userid: any, roleid: any, createdBy: any) {
    return this.httpClientService.post(`${CONFIG.AUTH.CREATEUSERROLE}?Userid=${Userid}&roleid=${roleid}&createdBy=${createdBy}`);
  }

  public updateuserRole(data: any) {
    return this.httpClientService.post(CONFIG.AUTH.UPDATEUSERROLE, data);
  }

}
